import { Icon, IconProps } from "@chakra-ui/react";

export function AttentionThickIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00037 11.2852C7.00037 10.7593 7.42669 10.333 7.95258 10.333H8.04781C8.5737 10.333 9.00002 10.7593 9.00002 11.2852V11.3804C9.00002 11.9063 8.5737 12.3327 8.04781 12.3327H7.95258C7.42669 12.3327 7.00037 11.9063 7.00037 11.3804V11.2852Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99995 3.66748C8.52584 3.66748 8.95217 4.0938 8.95217 4.6197V8.42857C8.95217 8.95447 8.52584 9.38079 7.99995 9.38079C7.47405 9.38079 7.04773 8.95447 7.04773 8.42857V4.6197C7.04773 4.0938 7.47405 3.66748 7.99995 3.66748Z"
        fill="currentColor"
      />
    </Icon>
  );
}
